import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { trackPageView } from "../lib/googleAnalytics.js"

export function AnalyticsPageViewTracker() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    trackPageView(pathname + search)
  }, [pathname, search])

  return null
}
